/** Entorno de DESARROLLO (ng serve / ng build --configuration development) */
export const environment = {
  production: false,
  /** Con `ng serve` + proxy.conf.json las peticiones van a localhost:2021 sin CORS. */
  apiBaseUrl: 'https://sistema-cobros-api-35546230649.us-central1.run.app/api/v1',
  // apiBaseUrl: 'http://localhost:2021/api/v1',
  publicAppUrl: 'https://app.platacheck.com',
};
